import React from 'react';
import {FormItem, InputType} from '@fs/uikit-react';
import styles from './PersonEdit.module.css';
import {
  Gender,
  GENDER_OPTIONS,
  getMaritalStatusOptions,
  MaritalStatus
} from '@/pages/Operator/Person/types/personConstants.ts';

export type PersonMainTabProps = {
  firstName: string;
  lastName: string;
  fathersName: string;
  dateOfBirth: string;
  gender: Gender;
  maritalStatus: MaritalStatus;
  comment: string;

  // Categories
  categoryOptions: { value: string; label: string }[];
  selectedCategoryIds: string[];
  onCategoriesChange: (value: string[]) => void;
  
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onFathersNameChange: (value: string) => void;
  onDateOfBirthChange: (value: string) => void;
  onGenderChange: (value: Gender) => void;
  onMaritalStatusChange: (value: MaritalStatus) => void;
  onCommentChange: (value: string) => void;
};

export const PersonMainTab: React.FC<PersonMainTabProps> = ({
  firstName,
  lastName,
  fathersName,
  dateOfBirth,
  gender,
  maritalStatus,
  comment,
  // categories
  categoryOptions,
  selectedCategoryIds,
  onCategoriesChange,
  onFirstNameChange,
  onLastNameChange,
  onFathersNameChange,
  onDateOfBirthChange,
  onGenderChange,
  onMaritalStatusChange,
  onCommentChange,
}) => {
  return (
    <>
      <div className={styles.row}>
        <FormItem
          label="Прізвище"
          type={InputType.TEXT}
          value={lastName}
          onChange={(e) => { onLastNameChange(e.target.value); }}
        />
        <FormItem
          label="Ім'я"
          type={InputType.TEXT}
          value={firstName}
          onChange={(e) => { onFirstNameChange(e.target.value); }}
        />
      </div>
      <div className={styles.row}>
        <FormItem
          label="По батькові"
          type={InputType.TEXT}
          value={fathersName}
          onChange={(e) => { onFathersNameChange(e.target.value); }}
        />
        <FormItem
          label="Дата народження"
          type={InputType.DATE}
          value={dateOfBirth}
          onChange={(e) => { onDateOfBirthChange(e.target.value); }}
        />
      </div>
      <div className={styles.row}>
        <FormItem
          label="Стать"
          type={InputType.SELECT}
          value={gender}
          onChange={(e) => { onGenderChange(e.target.value as Gender); }}
          options={GENDER_OPTIONS}
        />
        <FormItem
          label="Сімейний стан"
          type={InputType.SELECT}
          value={maritalStatus}
          onChange={(e) => { onMaritalStatusChange(e.target.value as MaritalStatus); }}
          options={getMaritalStatusOptions(gender)}
        />
      </div>

      <div className={styles.row}>
        <FormItem
          label="Категорії"
          type={InputType.MULTISELECT_SEARCHABLE}
          value={selectedCategoryIds}
          onChange={(e) => { onCategoriesChange(e.target.value as unknown as string[]); }}
          options={categoryOptions}
        />
      </div>

      <div className={styles.row}>
        <FormItem
          label="Коментар"
          type={InputType.TEXT_AREA}
          value={comment}
          onChange={(e) => { onCommentChange(e.target.value); }}
        />
      </div>
    </>
  );
};

export default PersonMainTab;
